import { MigratedLicenseKeysData } from "./model";


export function getAllIdNotMigratedLicenses(list: MigratedLicenseKeysData[]): number[] {
    const licenseKeys: number[] = [];

    list.forEach(el => {
        if (el.isMigrated === false) {
            licenseKeys.push(el.id);
        }
    });

    return licenseKeys
}